const UnifiedNavigation = () => {
  return null;
};

export default UnifiedNavigation;
